import Pulse from '@pulsejs/core';
const App = new Pulse();

export {App};
export default App;